import React from "react"
import styled from "styled-components"
import Layout from "../components/common/layout/layout"
import SEO from "../components/common/layout/seo"

import { Section, Container } from "../components/global"

const Privacy = () => (
  <Layout>
    <Section id="privacy">
      <StyledContainer>
        <SEO title="Privacy Policy" />
        <h1>Privacy Policy</h1>
        <p>
          Your privacy is important to us. It is the policy of Day (Ongaku
          Holding Corp.) to respect your privacy regarding any information we
          may collect from you across our website,{" "}
          <a href="https://www.trydayapp.com">https://www.trydayapp.com</a>, the
          Day mobile app, and other sites we own and operate.
        </p>
        <p>
          We only ask for personal information when we truly need it to provide
          a service to you. We collect it by fair and lawful means, with your
          knowledge and consent. We also let you know why we're collecting it
          and how it will be used.
        </p>
        <h3>Information we collect</h3>
        <p>
          When you use the Day app, we collect and store the information you
          choose to add to your daily practice, including:
        </p>
        <p>
          <strong>Account information</strong> — such as your username, avatar,
          and login credentials.
        </p>
        <p>
          <strong>Daily activity</strong> — the days you add, your intentions,
          streaks, milestones, and BTC points.
        </p>
        <p>
          <strong>Check-ins</strong> — moods, notes, and photos you attach to
          your days. If you attach a photo, the app requests access to your
          device's camera and/or photo library; that access is used only to
          capture or select the photo you choose.
        </p>
        <p>
          <strong>Community activity</strong> — cheers and reactions you send
          and receive.
        </p>
        <h3>Anonymous shared notes</h3>
        <p>
          Some notes may be shared with the Day community. Shared notes are
          always anonymous: they are never displayed with your name, username,
          avatar, or any link to your profile. Only the text of the note is
          shared.
        </p>
        <h3>How we use and protect your information</h3>
        <p>
          We only retain collected information for as long as necessary to
          provide you with your requested service. What data we store, we'll
          protect within commercially acceptable means to prevent loss and
          theft, as well as unauthorised access, disclosure, copying, use or
          modification.
        </p>
        <p>
          We don't share any personally identifying information publicly or
          with third-parties, except when required to by law.
        </p>
        <p>
          Our website may link to external sites that are not operated by us.
          Please be aware that we have no control over the content and
          practices of these sites, and cannot accept responsibility or
          liability for their respective privacy policies.
        </p>
        <p>
          You are free to refuse our request for your personal information,
          with the understanding that we may be unable to provide you with some
          of your desired services.
        </p>
        <p>
          Your continued use of our website and app will be regarded as
          acceptance of our practices around privacy and personal information.
          If you have any questions about how we handle user data and personal
          information, feel free to{" "}
          <a href="mailto:theschnaz@gmail.com">contact us</a>.
        </p>
        <h1>Data Deletion Process</h1>
        <p>
          To delete your account and data — including your days, moods, notes,
          and photos — request deletion in the app.
        </p>
      </StyledContainer>
    </Section>
  </Layout>
)

export default Privacy

const StyledContainer = styled(Container)``
